import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NetaxeptFinalizeRequest } from "src/app/model/api/api-request/netaxept-finalize-request";
import { NetaxeptFinalizeResponse } from "src/app/model/interfaces/netaxept-finalize-response";
import { NetaxeptRegisterPaymentResponse } from "src/app/model/interfaces/netaxept-register-payment-response";
import { AppConfigService } from "src/app/services/app-config.service";
import { NetaxeptRegisterPaymentRequest } from "../../model/api/api-request/netaxept-register-payment-request";
import { ApiClient } from "../api-client/api-client";

@Injectable({providedIn: 'root'})
export class NetaxeptRepository
{
    private readonly apiClient: ApiClient;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }
    
    public registerPayment(
        orderId: number,
        description: string,
        context: string,
        mobilePay: boolean): Observable<NetaxeptRegisterPaymentResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new NetaxeptRegisterPaymentRequest(orderId, description, context, mobilePay, webapiBasepath);
        return this.apiClient.post(request);
    }

    public finalizeTransaction(transactionId: string): Observable<NetaxeptFinalizeResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new NetaxeptFinalizeRequest(transactionId, webapiBasepath);
        return this.apiClient.put(request);
    }
}
